import { render, staticRenderFns } from "./RaceHeadline.vue?vue&type=template&id=b860eb82&scoped=true&"
import script from "./RaceHeadline.vue?vue&type=script&lang=js&"
export * from "./RaceHeadline.vue?vue&type=script&lang=js&"
import style0 from "./RaceHeadline.vue?vue&type=style&index=0&id=b860eb82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b860eb82",
  null
  
)

export default component.exports